export const uploadImage = async ({
  incomingFiles,
  supabase,
  userData,
  handleSnackbar,
}) => {
  try {
    let filePaths = [];

    const { data, error } = await supabase.storage
      .from("ooval-bucket")
      .upload(
        `organization_folders/${userData?.email.split("@")[1].split(".")[0]}/${
          incomingFiles.name
        }`,
        incomingFiles,
        {
          upsert: true,
        }
      );

    if (error) {
      console.log(error);
      handleSnackbar(error.message, "error");
      return;
    }

    const fileUrl = await getPublicUrl({ path: data.path, supabase });
    filePaths.push(fileUrl);

    return filePaths;
  } catch (err) {
    console.log(err);
    handleSnackbar(err.message, "error");
  }
};

const getPublicUrl = async ({ path, supabase }) => {
  const { data, error } = supabase.storage
    .from("ooval-bucket")
    .getPublicUrl(`${path}`);

  if (error) {
    console.log(error);
    return;
  }

  return data.publicUrl;
};
